import '@pds-react/grid/dist/grid.min.css';
import React, { createContext, useEffect, useState } from 'react';
import useLocalization from './hooks/localization';
import EmailSent from './pages/email-sent';
import EnterIdNumber from './pages/enter-id-number';
import Footer from './themes/footer';
import Header from './themes/header';
import { v4 as uuid } from 'uuid';
import ContactSupport from './pages/contact-support';
import { i18n } from 'i18next';
import { Col, Container, Row } from '@pds-react/grid';
import AnimatedIcon from '@pds-react/animatedIcon';
import '@pds-react/animatedIcon/dist/animatedIcon.min.css';
import BuiltNotActivated from './pages/built-not-activated';

export const SessionId = React.createContext<string>(uuid());

export enum AppState {
  COLLECT_CRD = 'COLLECT_CRD',
  EMAIL_SENT = 'EMAIL_SENT',
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
  BUILT_NOT_ACTIVATED = 'BUILT_NOT_ACTIVATED',
}

export interface AppPageProps {
  changeState: (newState: AppState) => void;
}

export const LocalizationContext = createContext<i18n | undefined>(undefined);

export interface AppProps {
  initialState?: AppState;
}

const App: React.FunctionComponent<AppProps> = (props: AppProps) => {
  const [localization, changeLanguage] = useLocalization();

  const [appState, setAppState] = useState<undefined | AppState>();

  useEffect(() => {
    // Set a timer to show error if localization fails to initialize.
    if (!localization.i18next.isInitialized && appState === undefined) {
      setTimeout(() => {
        if (!localization.i18next.isInitialized) {
          console.log('Localization failed to load.');
          setAppState(AppState.CONTACT_SUPPORT);
        }
      }, 3000);
    }

    // After localization has initialized, set initial state.
    if (localization.i18next.isInitialized && appState === undefined) {
      setAppState(props.initialState ? props.initialState : AppState.COLLECT_CRD);
    }
  }, [localization, appState, props.initialState]);

  return (
    <>
      <LocalizationContext.Provider value={localization.i18next}>
        <div style={{ display: 'flex', minHeight: '100vh', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Header changeLanguage={changeLanguage} />
          {appState === AppState.COLLECT_CRD && <EnterIdNumber changeState={setAppState} />}
          {appState === AppState.EMAIL_SENT && <EmailSent changeState={setAppState} />}
          {appState === AppState.BUILT_NOT_ACTIVATED && <BuiltNotActivated changeState={setAppState} />}
          {appState === AppState.CONTACT_SUPPORT && <ContactSupport />}
          {appState === undefined && (
            <Container style={{ marginTop: '40px', marginBottom: '40px' }}>
              <Row>
                <Col span={12} md={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }}>
                  <div className="pds-typography-center">
                    <AnimatedIcon style={{ height: '50px', width: '50px' }} animationType="rotate" aria-label="loading" name="loader" />
                  </div>
                </Col>
              </Row>
            </Container>
          )}
          <Footer />
        </div>
      </LocalizationContext.Provider>
    </>
  );
};

export default App;
